import styled from "styled-components";

export const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.color.white};
    height: 100%;
    width: 100%;
    z-index: ${({theme}) => theme.zIndex.contentFixed};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-top: 2.875rem;
`;

export const Content = styled.div`
    padding: 0.625rem 0.9375rem 1.25rem 0.9375rem;
`;